(function() {
  // 支持的语言前缀列表（可按需扩展）
  var supportedLangs = ['de', 'it', 'es', 'fr'];

  var browserLang = (navigator.language || navigator.userLanguage || '').toLowerCase();

  // 匹配浏览器语言到支持的语言前缀
  function matchLang(lang) {
    for (var i = 0; i < supportedLangs.length; i++) {
      var supported = supportedLangs[i].toLowerCase();
      // 精确匹配（如 pt-br）或前缀匹配（如 de-DE -> de）
      if (lang === supported || lang.indexOf(supported + '-') === 0) {
        return supportedLangs[i];
      }
    }
    // 仅用语言主码匹配（如 de-AT -> de）
    var mainCode = lang.split('-')[0];
    for (var j = 0; j < supportedLangs.length; j++) {
      if (supportedLangs[j].toLowerCase() === mainCode) {
        return supportedLangs[j];
      }
    }
    return null;
  }

  var targetLang = matchLang(browserLang);
  // 非支持语言或英语（默认语言）不处理
  if (!targetLang) return;

  var path = window.location.pathname;
  var langPrefix = '/' + targetLang.toLowerCase();

  // 已经包含目标语言前缀则不处理
  var regex = new RegExp('^/' + targetLang.replace('-', '\\-') + '(/|$)', 'i');
  if (regex.test(path)) return;

  // 检查是否已在其他支持的语言路径下（用户主动选了别的语言，不要覆盖）
  for (var k = 0; k < supportedLangs.length; k++) {
    var r = new RegExp('^/' + supportedLangs[k].replace('-', '\\-') + '(/|$)', 'i');
    if (r.test(path)) return;
  }

  // 排除 Shopify 后台预览、设计模式、checkout 等路径
  if (/^\/(admin|checkout|challenge|tools|services)/.test(path)) return;

  // 避免重复跳转：使用 sessionStorage 标记（同一会话只跳一次）
  var redirectKey = '__lang_redirected_' + targetLang;
  if (sessionStorage.getItem(redirectKey)) return;
  sessionStorage.setItem(redirectKey, '1');

  // 拼接语言前缀并跳转
  var newPath = langPrefix + (path === '/' ? '' : path) + window.location.search + window.location.hash;
  window.location.replace(newPath);
})();
